module.exports = __webpack_public_path__ + "static/media/succulents.cd768d7c.jpg";